import { useState } from "react";
import "./App.scss";
import { Landing } from "./components/Landing";
import { PlayerService } from "./services/PlayerService";
import { Game } from "./components/Game";

export type GameState = "new" | "playing" | "reset" | "victory";

const playerService = new PlayerService();

function App() {
  const [gameState, setGameState] = useState<GameState>("new");

  return (
    <div className="App">
      {gameState !== "playing" ? (
        <Landing
          playerService={playerService}
          gameState={gameState}
          setGameState={setGameState}
        />
      ) : (
        <Game setGameState={setGameState} />
      )}
    </div>
  );
}

export default App;
